import type { IssuedPushLogin, PushLogin } from '../api/types'

/** Live, or the day it was revoked. */
export function loginStatus(login: PushLogin): string {
  return login.revoked_at ? `revoked ${login.revoked_at.slice(0, 10)}` : 'live'
}

/** What the technician enters in Commander, as label/value pairs. A basic
 *  login is the logger id and the secret; a path login (the MRL-7) is the
 *  secret as one path segment. */
export function howToEnter(issued: IssuedPushLogin): [string, string][] {
  return issued.kind === 'basic'
    ? [['Username', issued.logger_id], ['Password', issued.secret]]
    : [['Path', `/push/${issued.secret}`]]
}
